<template>
  <v-navigation-drawer
    app
    clipped
    permanent
    :mini-variant="mini"
  >
    <template #prepend>
      <BProfileCard
        v-if="profile"
        :profile="profile"
        :mini="mini"
        :link="profileRoute"
        two-line
      />
    </template>

    <v-divider />

    <BMenuList
      v-if="isActive"
      :menu-list="menuList"
      :selected-menu-system="selectedMenuSystem"
      :mini="mini"
    />

    <template #append>
      <BToggleButton
        :value="mini"
        @toggle="$emit('toggle')"
      />
    </template>
  </v-navigation-drawer>
</template>

<script>
import { USERS_ROUTES } from '@/views/Users/utils'

import BProfileCard from './components/BProfileCard.vue'
import BMenuList from './components/BMenuList.vue'
import BToggleButton from './BToggleButton.vue'


export default {
  name: 'BNavigationDrawer',
  components: {
    BProfileCard,
    BMenuList,
    BToggleButton,
  },
  props: {
    profile: Object,
    selectedMenuSystem: Object,
    menu: {
      type: Array,
      required: true,
    },
    mini: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
      menuList: this.menu,
      profileRoute: { name: USERS_ROUTES.PROFILE },
    }
  },
  watch: {
    menu: 'updateActiveMenu',
    selectedMenuSystem: 'updateActiveMenu',
    $route: 'updateActiveMenu',
  },
  created() {
    // Пока роутер не загрузиться, прячем
    this.$router.onReady(() => { this.isActive = true })
  },
  mounted() {
    this.updateActiveMenu()
  },
  methods: {
    updateActiveMenu() {
      const { name } = this.$route
      const { selectedMenuSystem } = this

      this.menuList = this.menu
        .filter((_) => _.folder === selectedMenuSystem.name)
        .map((menu) => {
          const active = name?.includes(menu.id.split('.')[0])
          if (!active) return menu
          return { ...menu, active }
        })
    },
  },
}
</script>
